export default {"src":"/_next/static/media/sports10.6d008c02.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};